import { useGetEnvironmentReport } from '@/lib/queries/reports';
import { downloadBlob } from '@/lib/utils/downloadBlob';
import { DownloadOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import React from 'react';

interface DownloadableEnvironmentReport {
  id?: number;
  registratieJaar?: number;
  bedrijfsNaam?: string;
}

interface DownloadEnvReportButtonProps {
  reportData?: DownloadableEnvironmentReport;
}

export const DownloadEnvReportButton: React.FunctionComponent<DownloadEnvReportButtonProps> = ({ reportData }) => {
  const { isLoading, refetch } = useGetEnvironmentReport(reportData?.id, reportData?.registratieJaar);
  const disabled = !reportData?.id || !reportData?.registratieJaar;

  const onClick = () => {
    refetch()
      .then(e => e.data)
      .then(blob => {
        if (blob && blob.type !== 'text/html') {
          downloadBlob(blob, `milieu_rapportage_${reportData?.bedrijfsNaam ?? 'rapportage'}_${reportData?.registratieJaar}.xlsx`);
        }
      })
      .catch(err => {
        console.error(`failed to fetch report for teeltplan with id '${reportData?.id}': ${err}`);
      });
  };

  return <Button loading={isLoading} disabled={disabled} icon={<DownloadOutlined />} title="Milieurapport downloaden" onClick={onClick} />;
};
